<template>
  <div class="leftNav" :style="pageType == 'list' ? 'padding-top:0' : ''">
    <div class="navBox">
      <div class="letNavTitle">{{ navTitle }}</div>

      <div
        :class="`navItem ${selectIndex == index ? 'selected' : ''}`"
        @click="navItemClick(item, index)"
        v-for="(item, index) of navList"
        :key="index"
        :title="item.name"
      >
        {{ item.name }}
      </div>
    </div>

    <!-- 推荐阅读 -->
    <div v-if="showTjState && newsList.length" class="navBox mt30">
      <div class="letNavTitle">推荐阅读</div>
      <div
        class="navItem elli fs14"
        style="padding-right: 10px"
        @click="newsItemClick(item)"
        v-for="(item, index) of newsList"
        :key="index"
        :title="item.title"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="navbox2 mt30">
      <div class="letNavTitle">联系方式</div>
      <div class="navItem2 mt20">公司：哈尔滨市物业管理协会</div>
      <div class="navItem2 dflex">
        地址：
        <span class="flex-sub" style="width: 0">哈尔滨市道里区建安路 爱建公寓A座106</span>
      </div>
      <div class="navItem2">电话：0451-87696938</div>
      <div class="navItem2">邮编：150000</div>
    </div>
  </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
import { mapGetters } from 'vuex'
import { routes } from '@/router/index'

import {
  findArticlePage, // 分页接口
} from '@/api/index'

export default {
  props: {
    pageType: {},
  },
  components: {},
  data() {
    return {
      showTjState: false, // 推荐状态
      linkInfoUrl: '', // 跳转地址
      routes: [],
      selectIndex: 0,
      navList: [],
      navTitle: '',

      // 推荐阅读
      newsList: [
        { id: 1, name: '1爱护母亲河  清理垃爱上了对方就爱上对方' },
        { id: 2, name: '2爱护母亲河  清理垃爱上了对方就爱上对方' },
        { id: 3, name: '3爱护母亲河  清理垃爱上了对方就爱上对方' },
        { id: 4, name: '爱护母4亲河  清理垃爱上了对方就爱上对方' },
        { id: 5, name: '爱护5母亲河  清理垃爱上了对方就爱上对方' },
      ],

      // 联系我们
      contantInformationList: {},
    }
  },
  created() {},
  computed: {},
  watch: {
    '$route.path': {
      handler(val) {
        // 跳转路由
        this.showTjState = true
        if (val.indexOf('/info') >= 0) {
          let preUrl = val.split('/info')[0]
          this.linkInfoUrl = preUrl + '/info'
        } else if (val.indexOf('/list') >= 0) {
          let preUrl = val.split('/list')[0]
          this.linkInfoUrl = preUrl + '/info'
        } else {
          this.showTjState = false
        }

        // 获取左侧导航
        this.getLeftNav(val)
        this.getTjydList()
      },
      immediate: true,
    },
  },
  mounted() {},

  methods: {
    getLeftNav(val) {
      let routes = JSON.parse(JSON.stringify(this.$router.options.routes))

      let linkUrl
      let navList = []
      for (let item of routes) {
        if (val.indexOf(item.path) >= 0 && item.path.length > 1) {
          linkUrl = item.path + '/'

          for (let childrenItem of item.children) {
            if (childrenItem.meta && childrenItem.meta.hidden) {
            } else {
              navList.push(childrenItem)
            }
          }

          if (item.meta) {
            this.navTitle = item.meta.title
          } else {
            this.navTitle = item.children[0].meta.title
          }
          break
        }
      }
      this.selectIndex = 0
      let lastPathArr = val.split('/')
      let lastPath = lastPathArr[lastPathArr.length - 2]
      if (!this.showTjState) {
        lastPath = lastPathArr[lastPathArr.length - 1]
      } else if (this.pageType == 'info') {
        lastPath = lastPathArr[lastPathArr.length - 3]
      }
      for (let i = 0; i < navList.length; i++) {
        let item = navList[i]
        if (item.path) {
          item.linkUrl = linkUrl + item.path
        } else {
          item.linkUrl = linkUrl
        }

        // console.log("item.path.split('/')[0]", item.path.split('/')[0])
        // console.log('lastPath', lastPath)
        if (item.path.split('/')[0] == lastPath) this.selectIndex = i
      }
      this.navList = JSON.parse(JSON.stringify(navList))
    },
    // 导航点击
    navItemClick(item, index) {
      console.log('item', item)
      this.selectIndex = index
      this.$router.push({ path: item.linkUrl })
    },

    // -- 推荐阅读
    // 列表
    getTjydList() {
      let sendObj = {
        label: '',
        page: 1,
        limit: 6,
        colId: this.$route.meta.id,
        typeValue: 1, // 0-置顶 1-推荐 2-幻灯片 3-视频
        isAudit: '1', // 0 待审核 1 审核通过(正常) 2 审核不通过(不显示)
      }
      findArticlePage(sendObj).then((res) => {
        if (res.code == 200) {
          this.newsList = res.data ? res.data : []
          this.total = res.page ? res.page.total : 0
        }
      })
    },
    // 推荐阅读
    newsItemClick(item) {
      // let url = '新闻详情'
      window.sessionStorage.pageData = JSON.stringify(item)
      this.$router.push({ path: this.linkInfoUrl + '/' + item.id })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.leftNav {
  width: 290px;
  padding: 40px;
  // padding-top: 0;
  background: #fff;
  .navBox {
    background: #f7f7f7;
  }
  .letNavTitle {
    line-height: 48px;
    height: 48px;
    background: #4a7cf5;
    text-align: center;
    color: #fff;
  }

  .navItem {
    line-height: 48px;
    height: 48px;

    cursor: pointer;
    text-align: left;
    padding-left: 24px;
    border-top: 1px solid #ffffff;
    color: #333333;
    &.selected {
      color: #4a7cf5;
    }
    &:hover {
      color: #4a7cf5;
    }
  }

  .navbox2 {
    color: #333333;
    background: #f7f7f7;
    padding-bottom: 20px;
    .navItem2 {
      font-size: 14px;

      padding-left: 24px;
      text-align: left;
      margin-top: 10px;
      padding-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/leftNav.vue